import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable } from 'rxjs';
import { IAPIKeyResponse } from '../models';

@Injectable()
export class APIKeyService extends BaseApiService {
  constructor(protected injector: Injector) {
    super(injector);
  }

  public getApiKey(): Observable<IAPIKeyResponse> {
    const endPoint = `${this.endPointNB}/publicapi/key`;
    return this.httpAuthGet<IAPIKeyResponse>(endPoint);
  }

  public requestApiKey(): Observable<IAPIKeyResponse> {
    const endPoint = `${this.endPointNB}/publicapi/key`;
    return this.httpAuthPost<IAPIKeyResponse>(endPoint, {});
  }
}
